import { List } from 'immutable';
import { isFieldRestricted } from '../../../utils/fieldLevelPermissions';
import { useMemo } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
const SimpleEnumQuickFilterButton = ({
  ButtonContent,
  buttonProperties,
  dropdownFooter,
  isOptionsSelectDisabled,
  placement,
  property,
  value,
  onChange
}) => {
  const isRestrictedField = isFieldRestricted(property.accessLevel);
  const options = useMemo(() => property.options && List(property.options.map(option => ({
    disabled: isOptionsSelectDisabled,
    text: option.label,
    value: option.value
  }))).toJS(), [isOptionsSelectDisabled, property.options]);
  return /*#__PURE__*/_jsx(UISelect, {
    anchorType: "button",
    ButtonContent: ButtonContent,
    buttonSize: buttonProperties.BUTTON_SIZE,
    buttonUse: buttonProperties.BUTTON_USE,
    disabled: isRestrictedField || property.disabled,
    dropdownFooter: dropdownFooter,
    menuWidth: "auto",
    multi: true,
    options: options,
    placement: placement,
    value: value,
    onChange: onChange
  });
};
export default SimpleEnumQuickFilterButton;